import React from 'react';
import Util from '../Util';

class HostSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { hostInfo, hideCPUInfo } = this.props;
    let { externalIP } = hostInfo;
    if (externalIP && !Util.isValidIpAddress(externalIP)) {
      externalIP = '-';
    }

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ backgroundColor: 'white', paddingBottom: 0, marginBottom: 10 }}
      >
        <div className='info-card pure-u-4-24'>
          <span>Internal IP Address:</span>
          <div>{hostInfo.ip}</div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>Mac Address:</span>
          <div>{hostInfo.macAddress}</div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>External IP Address:</span>
          {externalIP}
        </div>
        <div className='info-card pure-u-4-24'>
          <span>Host Type:</span>
          <div>{hostInfo.hostType}</div>
        </div>
        <div className='info-card pure-u-8-24'>
          <span>Hostname:</span>
          <div>{hostInfo.hostname}</div>
        </div>

        <div className='info-card pure-u-4-24' style={{ display: hideCPUInfo ? 'none' : '' }}>
          <span>1 Min LoadAvg:</span>
          <div style={{ color: Util.calcLoadAvgColor(hostInfo.cpu1MinLoadAvgPercent) }}>
            {hostInfo.cpu1MinLoadAvgPercent} %
          </div>
        </div>
        <div className='info-card pure-u-4-24' style={{ display: hideCPUInfo ? 'none' : '' }}>
          <span>5 Min LoadAvg:</span>
          <div style={{ color: Util.calcLoadAvgColor(hostInfo.cpu5MinLoadAvgPercent) }}>
            {hostInfo.cpu5MinLoadAvgPercent} %
          </div>
        </div>
        <div className='info-card pure-u-4-24' style={{ display: hideCPUInfo ? 'none' : '' }}>
          <span>15 Min LoadAvg:</span>
          <div style={{ color: Util.calcLoadAvgColor(hostInfo.cpu15MinLoadAvgPercent) }}>
            {hostInfo.cpu15MinLoadAvgPercent} %
          </div>
        </div>
        <div className='info-card pure-u-12-24' style={{ display: hideCPUInfo ? 'none' : '' }}>
          <span>CPU:</span>
          {hostInfo.cpuNumOfCores}
        </div>

        <div className='info-card pure-u-4-24'>
          <span>Memory Usage:</span>
          <div style={{ color: Util.calcMemUsageColor(hostInfo.memUsedPercent) }}>
            {hostInfo.memUsedPercent} % of {hostInfo.memTotal}
          </div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>Usage of /:</span>
          <div style={{ color: Util.calcDiskUsageColor(hostInfo.diskUsedPercent) }}>
            {hostInfo.diskUsedPercent} % of {hostInfo.diskTotal}
          </div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>CPU Load Average (15 Minutes):</span>
          <div style={{ color: Util.calcLoadAvgColor(hostInfo.cpu15MinLoadAvg) }}>
            {hostInfo.cpu15MinLoadAvgPercent} %
          </div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>Total Processes:</span>
          <div>{hostInfo.totalProcesses}</div>
        </div>
        <div className='info-card pure-u-8-24'>
          <span>OS:</span>
          <div>{hostInfo.os}</div>
        </div>

        <div className='info-card pure-u-6-24'>
          <span>Uptime:</span>
          <div>{hostInfo.uptime}</div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Upsince:</span>
          <div>{hostInfo.upsince}</div>
        </div>
        {hostInfo.hasKioskInfo ? (
          <div className='info-card pure-u-6-24'>
            <span>TeamViewer Client ID:</span>
            <div>{hostInfo.teamviewerClientID}</div>
          </div>
        ) : (
          <div className='info-card pure-u-6-24'>
            <span>Installed At:</span>
            <div>{hostInfo.installedAt}</div>
          </div>
        )}
        <div className='info-card pure-u-6-24'>
          <span>Timezone:</span>
          <div>
            {hostInfo.timezone}
            <br />
            {hostInfo.timezoneLong}
          </div>
        </div>
      </div>
    );
  }
}

export default HostSummary;



// WEBPACK FOOTER //
// ./src/components/HostSummary.js